import { SGA_LOGIN_DIALOG_ID } from "@obg/mat.ui.common";
import { DialogLike } from "@obg/mat.ui.core";

import { VerificationLoginData } from "./verification-login.model";
import { VerificationSgaLoginContainer } from "./verification-sga-login.container";

export function sgaVerificationLoginDialogFactory(
	verificationLoginData: VerificationLoginData | undefined
): DialogLike<VerificationSgaLoginContainer> {
	return {
		dialogComponentType: VerificationSgaLoginContainer,
		dialogId: SGA_LOGIN_DIALOG_ID,
		onBusy$: (c) => c.busy,
		init: (c) => (c.verificationLoginData = verificationLoginData),
	};
}
